<template>
  <Modal
    :id="'cmp-b2b-edit-user'"
    class="cmp-b2b-edit-user"
    @cancelled="onCancel"
  >
    <template slot="header"> {{ $t("detailsb2b_edit_user") }}</template>
    <template slot="body">
      <div class="form-group">
        <div class="field-content">
          <span :title="$t('username_info')" class="img-info">
            <img src="static/icons/b2b/icon___information.svg" />
          </span>
          <span  style="padding-bottom:10px;color:#a09e9e">{{ userInfo.user_name }}</span>
        </div>
        <div class="field-content">
          <span :title="$t('detailsb2b_user_fullname')" class="img-info">
            <img src="static/icons/b2b/icon___information.svg" />
          </span>
          <TextField
            class="m1"
            style="width: 100%"
            :id="'userName'"
            required
            v-bind="textFieldConfig"
            v-model="userInfo.given_name"
            @validated="onValidation"
            isModel
            :placeholder="$t('detailsb2b_user_name')"
            @valuechanged="onTextFieldValueChange"
          ></TextField>
        </div>
        <div class="field-content">
          <span :title="$t('detailsb2b_user_email')" class="img-info">
            <img src="static/icons/b2b/icon___information.svg" />
          </span>
          <TextField
            style="width: 100%"
            class="m1"
            :id="'email'"
            required
            :showValidationIcons="false"
            :disabled="true"
            v-bind="textFieldConfig"
            v-model="userInfo.email"
            :validators="emailValidators"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
            isModel
            :placeholder="$t('detailsb2b_email')"
          ></TextField>
        </div>

        <TextField
          class="m1"
          :id="'mobile'"
          :showValidationIcons="false"
          v-bind="textFieldConfig"
          v-model="userInfo.mobile"
          isModel
          :placeholder="$t('detailsb2b_mobile')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>

        <Dropdown
          class="dt-dropdown m2"
          :options="languageList"
          box
          :placeholder="$t('detailsb2b_language')"
          v-on:selectedChange="(e) => onDropdownChange('language', e)"
          :listHeight="150"
          :selected="languageList.find((x) => x.value === userInfo.language)"
        ></Dropdown>
        <div :title="$t('detailsb2b_user_pwd')" class="field-content">
          <span class="img-info">
            <img src="static/icons/b2b/icon___information.svg" />
          </span>
          <TextField
            style="width: 100%"
            class="m1"
            :id="'password'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            v-model="userInfo.password"
            :password="true"
            :disabled="true"
            isModel
            :placeholder="$t('detailsb2b_password')"
          ></TextField>
        </div>
      </div>
      <button
        class="dt-button v3 c5 change_password_button"
        @click.stop="onChangePassword"
      >
        <span> Change Password</span>
      </button>
    </template>

    <template slot="options">
      <button @click.stop="onCancel" class="dt-button s6">
        {{ $t("detailsb2b_cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="onSave"
        class="dt-button v1 with-ico s6"
      >
        <div class="button-text">
          {{ $t("detailsb2b_save") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import { B2BStoreNamespace as storeNS } from "../../store/index";
import * as types from "../../store/types";
import { createValidator } from "@plugins/text-field";
import isEmail from "validator/lib/isEmail";
import * as I18nActionTypes from "../../../../store/app/i18n/types";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import Modal from "@dtplugins/modal/modal";

import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      textFieldConfig: createTextFieldConfig({
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
      }),
      emailValidators: [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email",
        }),
      ],

      validationResult: {},
    };
  },
  mounted() {
    this[types.B2B_FETCH_USER_INFO]();
    this[types.B2B_FETCH_LANGUAGES]();
  },
  computed: {
    ...mapGetters(storeNS, {
      userInfo: "userInfo",
      languages: "languages",
      user: "user",
    }),
    languageList: function () {
      return this.languages.map((x) => ({
        text: x[1],
        value: x[0],
      }));
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },
  methods: {
    ...mapActions(storeNS, {
      [types.B2B_SET_USER_INFO]: types.B2B_SET_USER_INFO,
      [types.B2B_UPDATE_USER_INFO]: types.B2B_UPDATE_USER_INFO,
      [types.B2B_FETCH_USER_INFO]: types.B2B_FETCH_USER_INFO,
      [types.B2B_FETCH_LANGUAGES]: types.B2B_FETCH_LANGUAGES,
    }),
    ...mapMutations(storeNS, {
      [types.B2B_SET_USER_INFO]: types.B2B_SET_USER_INFO,
    }),
    onChangePassword: function () {
      window.open(this.userInfo.reset_pw_url, "_self");
    },
    onTextFieldValueChange: function (name, value) {
      this.userInfo[name] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },

    onDropdownChange(action, data) {
      this.userInfo.language = data.value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    onSave(e) {
      e.preventDefault();
      this[types.B2B_UPDATE_USER_INFO]()
        .then((res) => {
          this.userInfo.password = this.userInfo.currentPassword;
          this.$store.commit(
            `${storeNS}/${types.B2B_SET_USER_INFO}`,
            this.userInfo
          );
          this.$store.dispatch(I18nActionTypes.UPDATE_SYSTEM_LANGUAGE, {
            value: this.userInfo.language,
            text: "English",
          });
          this.onCancel();
        })
        .catch((error) => {});
    },
  },
};
export const stringRequired = (str) => str && str.length > 0;
const minLength = (len) => (str) =>
  stringRequired(str) && str.length >= len ? true : false;
const minLen5 = minLength(5);
</script>

<style  lang="scss" >
.cmp-b2b-edit-user {
  .dt-modal--header {
    color: #4fe890 !important;
  }
  .change_password_button {
    margin-top: 10px;
    color: #4fe890 !important;
    margin-left: -4px;
  }
  .field-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
    .img-info {
      position: absolute;
      left: 12px;
      cursor:pointer;
      @media (min-width: 320px) and (max-width: 480px) {
        left: 5px;
      }
    }
  }
  @media (min-width: 320px) and (max-width: 480px) {
    padding: 30px !important;
  }
}
</style>